import { Observable } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { GenericRepository } from "../../generic-repository/GenericRepository";
import { ResponseModel } from "../../../models/SharedModels/response.model";
import { environment } from "../../../../environments/environment";
import { INozelRepository } from "./INozelRepository";
import { Nozel } from "src/app/models/HR/Nozel/nozel";

@Injectable()
export class NozelRepository extends GenericRepository<Nozel> implements INozelRepository {
 
  url: string = environment.urlAddress;
  constructor(protected _http: HttpClient) {
      super(_http, 'api/Nozel', environment.urlAddress);
    }   
    GetAll(currentPage: number, recordsPerPage: number): Observable<any> {
        return this._http
          .get(this.url + 'api/Nozel/SelectAll' + '/' + currentPage + '/' + recordsPerPage, this.httpOptions).pipe(map(this.extractData), catchError(this.handleError));
    }
    DeleteRec(code: string): Observable<any> {
        return this._http
        .delete(this.url + 'api/Nozel/DeleteRec' + '/' + code, this.httpOptions)
        .pipe(map(this.extractData), catchError(this.handleError));
    }
    GetNozelOnDimension(isDimensional?: boolean): Observable<any> {
    return this._http
        .get(this.url + 'api/Nozel/SearchNozel' + '/' + isDimensional, this.httpOptions).pipe(map(this.extractData), catchError(this.handleError));
    }
    GetAllNozel(uomCode:string = ""): Observable<any> {
        return this._http
        .get(this.url + 'api/Nozel/GetRec' + '/' + uomCode, this.httpOptions).pipe(map(this.extractData), catchError(this.handleError));
    }
}